import React from 'react';
import MasterDataListPage from './MasterDataListPage';

const UsersPage = () => {
  return <MasterDataListPage type="users" />;
};

export default UsersPage;